<template>
  <v-toolbar color="primary" style="z-index: 999999" fixed dark app>
    <v-btn icon flat @click="goBack" title="Back" class="ml-2">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 pl-3 pr-3">
      <v-toolbar-side-icon
        @click.stop="handleDrawerToggle"
      ></v-toolbar-side-icon>
      Snap Drive
    </v-toolbar-title>
    <!-- <v-autocomplete
      @change="goToPassengerProfile"
      :items="searchResults"
      :loading="loading"
      :search-input.sync="search"
      item-value="id"
      item-text="username"
      no-filter
      flat
      solo-inverted
      class="hidden-sm-and-down"
      label="Start typing to Search"
      prepend-inner-icon="search"
    >
      <template slot="item" slot-scope="data">
        <v-list-tile-avatar>
          <img
            :src="api.GET_IMAGE(data.item.profile_image)"
            :alt="data.item.id"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            v-html="data.item.first_name + ' ' + data.item.last_name"
          ></v-list-tile-title>
          <v-list-tile-sub-title
            v-html="data.item.username"
          ></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
      <v-icon>mdi-filter</v-icon>
    </v-autocomplete> -->
    <v-spacer></v-spacer>

    <v-btn icon flat title="Logout" @click="logout">
      <v-icon>exit_to_app</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
import { getFirstAllowedPage, canAccessRoute } from "@/utils/permissionHelpers";

export default {
  name: "app-toolbar",
  components: {
  },
  methods: {
    goBack() {
      const userPermissions = (this.$store.state.user && this.$store.state.user.permissions) || [];
      const firstPage = getFirstAllowedPage(userPermissions);
      
      if (window.history.length > 1) {
        // Store current route before going back
        const currentRouteName = this.$route.name;
        
        // Try to go back
        this.$router.go(-1);
        
        // After navigation, check if current route is accessible
        // Use a timeout to ensure navigation is complete
        setTimeout(() => {
          const newRouteName = this.$route.name;
          
          // If we're still on the same route or don't have permission, redirect
          if (newRouteName === currentRouteName || (newRouteName && !canAccessRoute(newRouteName, userPermissions))) {
            // If we don't have permission for the page we went back to,
            // redirect to first allowed page
            this.$router.push(firstPage).catch(() => {
              // Ignore navigation errors (e.g., if already on that page)
            });
          }
        }, 100);
      } else {
        // No history, go to first allowed page
        this.$router.push(firstPage);
      }
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    logout() {
      this.axios
        .put(this.api.ACTIONS.LOGOUT)
        .then(() => {
          window.getApp.$emit("APP_LOGOUT");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", "err (check console)");
          console.log(err);
          console.log(err.response);
          console.log(err.response.data);
        })
        .finally(() => {
          this.$store.commit("LOGOUT");
          this.$router.push({ name: "Login" });
        });
    },
  },
};
</script>

<style scoped>
.v-toolbar {
  touch-action: pan-x pan-y !important;
  overflow: visible !important;
}
</style>
